module.exports = __webpack_public_path__ + "static/img/logistics-tracking.7a1ff6b8.png";